/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        table: {
            header: {
                backgroundColor: {
                    value: "#f3f3f3",
                    type: "color",
                },
                borderBottomColor: {
                    value: "#dadada",
                    type: "color",
                },
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderBottomStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.3px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                first: {
                    borderTopLeftRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                },
                last: {
                    borderTopRightRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
            row: {
                default: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                },
                selected: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
            cell: {
                borderBottomColor: {
                    value: "#dadada",
                    type: "color",
                },
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderBottomStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
            },
            footer: {
                container: {
                    gap: {
                        value: "16px",
                        type: "dimension",
                    },
                    marginTop: {
                        value: "24px",
                        type: "dimension",
                    },
                },
                label: {
                    color: {
                        value: "#6f7377",
                        type: "color",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                },
                range: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    borderLeftWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderLeftColor: {
                        value: "#dadada",
                        type: "color",
                    },
                    borderLeftStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    paddingLeft: {
                        value: "20px",
                        type: "dimension",
                    },
                    total: {
                        color: {
                            value: "#6f7377",
                            type: "color",
                        },
                    },
                },
                rowsPerPages: {
                    width: {
                        value: "100px",
                        type: "dimension",
                    },
                },
            },
            columnSeparator: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            small: {
                header: {
                    height: {
                        value: "40px",
                        type: "dimension",
                    },
                },
                cell: {
                    height: {
                        value: "44px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "8px",
                        type: "dimension",
                    },
                },
            },
            medium: {
                header: {
                    height: {
                        value: "48px",
                        type: "dimension",
                    },
                },
                cell: {
                    height: {
                        value: "64px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "12px",
                        type: "dimension",
                    },
                },
            },
            large: {
                header: {
                    height: {
                        value: "56px",
                        type: "dimension",
                    },
                },
                cell: {
                    height: {
                        value: "72px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "16px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
